import './index.scss'
import { useState } from 'react'
import { submitSubscription } from '@/api/home'
import { useMediaQuery } from 'react-responsive';
import DisplayText from '@/components/DisplayText';
import { message } from 'antd';
import { Link } from 'react-router-dom';

const Stack = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const [email, setEmail] = useState('')

  const onSubmit = async () => {
    if (email === '') return message.error('Please enter your email！');
    const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!emailReg.test(email)) return message.error('Please enter a valid email address！');

    try {
      message.success('Successfully');
      submitSubscription({email})
      setEmail('')
    } catch (e) {
    }
  }

  return (
    <div className="stack">
      <div className="stack-inner">
        <div className={`max-w-[920px] h-[226px]`}>
          <DisplayText fullText="The rules for autonomous capital are being written" />
        </div>
        {/*<p className={`stack-inner-subtitle mt-[20px]`}>Vishwa defines how they are enforced.</p>*/}

        {/* Actions Row */}
        <div className={`stack-actions ${isMobile ? 'stack-actions-mobile' : ''}`}>
          {/* Stay Posted */}
          <div className="stack-action-block">
            <div className="stack-action-label my-[24px]">Vishwa defines how they are enforced.</div>
            <div className="stack-subscribe">
              {/*<input*/}
              {/*  className="stack-subscribe-input"*/}
              {/*  type="email"*/}
              {/*  placeholder="Email address"*/}
              {/*  value={email}*/}
              {/*  onChange={(e) => setEmail(e.target.value)}*/}
              {/*/>*/}
              {/*<button className="stack-subscribe-btn get-touch-btn" onClick={onSubmit}>*/}
              {/*  <span className="get-touch-btn-text">Subscribe</span>*/}
              {/*  <span className="get-touch-mask" />*/}
              {/*</button>*/}
              {/*<a*/}
              {/*  href="https://calendly.com/d/cm55-bjj-2ck/meeting-with-vishwa-team"*/}
              {/*  target="_blank"*/}
              {/*  rel="noopener noreferrer"*/}
              {/*  className="stack-meeting-btn get-touch-btn"*/}
              {/*>*/}
              {/*  <span className="get-touch-btn-text">Request Demo</span>*/}
              {/*  <span className="get-touch-mask" />*/}
              {/*</a>*/}
              <Link className={`stack-meeting-btn get-touch-btn`} target="_blank"
                    to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                <span className={`get-touch-btn-text text-[16px]`}>Request Demo</span>
                <span className={`get-touch-mask`} />
              </Link>
              <br />
              <a
                href="https://calendly.com/d/cm55-bjj-2ck/meeting-with-vishwa-team"
                target="_blank"
                rel="noopener noreferrer"
                className="stack-meeting-btn get-touch-btn"
              >
                <span className="get-touch-btn-text">Book a Meeting</span>
                <span className="get-touch-mask" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Stack
